// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"325":"ba2750a2","557":"f64138ca","639":"8973e7af","666":"2f684a94","873":"22b6da0e"}[chunkId] + ".chunk.css";
};